export type RolesTranslation = {
  error: {
    ADMIN_ROLE_PERMISSIONS_LOCKED: string;
    ROLE_ASSIGNED_TO_USERS: string;
    ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE: string;
    ROLE_NAME_REQUIRED: string;
    ROLE_NAME_TAKEN: string;
    ROLE_NAME_TOO_LONG: string;
    ROLE_NOT_FOUND: string;
    ROLE_PERMISSION_UNKNOWN: string;
    SYSTEM_ROLE_NAME_LOCKED: string;
    SYSTEM_ROLE_NOT_DELETABLE: string;
    unknown: string;
  };
  form: {
    assignedUsers: string;
    cancel: string;
    create: string;
    delete: string;
    deleteDialog: {
      content: string;
      title: string;
    };
    hierarchyLevel: string;
    hierarchyLevelHelper: string;
    loadError: string;
    loading: string;
    name: string;
    newRoleTitle: string;
    noPermissionsWithoutEdit: string;
    readOnly: string;
    save: string;
    systemRole: string;
    systemRoleHint: string;
    systemRoleNameHelper: string;
    unsavedChanges: string;
  };
  history: {
    author: string;
    createdAt: string;
    description: string;
    empty: string;
    heading: string;
    loadError: string;
    loading: string;
    rowsPerPage: string;
    systemAuthor: string;
    type: string;
    types: {
      RECURRING_RESERVATION_CHANGE: string;
      ROLE_CHANGE: string;
    };
  };
  list: {
    ariaLabel: string;
    empty: string;
    heading: string;
    hierarchyLevel: string;
    newRole: string;
    system: string;
  };
  matrix: {
    ariaLabel: string;
    heading: string;
    lockedPermissions: string;
  };
  tabs: {
    ariaLabel: string;
    history: string;
    roles: string;
  };
};

export const rolesTranslation: RolesTranslation = {
  error: {
    ADMIN_ROLE_PERMISSIONS_LOCKED:
      'Rola Administrator musi zachować odczyt i edycję ról, aby nikt nie utracił dostępu do zarządzania rolami.',
    ROLE_ASSIGNED_TO_USERS:
      'Nie można usunąć roli przypisanej użytkownikom (liczba użytkowników: {{count}}). Najpierw zmień im rolę.',
    ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE: 'Poziom hierarchii musi mieścić się w zakresie 0–1000.',
    ROLE_NAME_REQUIRED: 'Nazwa roli jest wymagana.',
    ROLE_NAME_TAKEN: 'Rola o tej nazwie już istnieje.',
    ROLE_NAME_TOO_LONG: 'Nazwa roli może mieć najwyżej 100 znaków.',
    ROLE_NOT_FOUND: 'Ta rola już nie istnieje. Odśwież listę ról.',
    ROLE_PERMISSION_UNKNOWN: 'Wybrano nieznane uprawnienie. Odśwież stronę i spróbuj ponownie.',
    SYSTEM_ROLE_NAME_LOCKED: 'Nazwy roli systemowej nie można zmienić.',
    SYSTEM_ROLE_NOT_DELETABLE: 'Roli systemowej nie można usunąć.',
    unknown: 'Operacja na roli nie powiodła się. Spróbuj ponownie.',
  },
  form: {
    assignedUsers: 'Przypisani użytkownicy: {{count}}',
    cancel: 'Odrzuć zmiany',
    create: 'Utwórz rolę',
    delete: 'Usuń rolę',
    deleteDialog: {
      content: 'Rola zostanie usunięta: ',
      title: 'Czy na pewno chcesz usunąć tę rolę?',
    },
    hierarchyLevel: 'Poziom hierarchii',
    hierarchyLevelHelper: 'Od 0 do 1000; niższa wartość oznacza wyższą pozycję w hierarchii.',
    loadError: 'Nie udało się wczytać roli. Spróbuj ponownie.',
    loading: 'Wczytywanie roli',
    name: 'Nazwa roli',
    newRoleTitle: 'Nowa rola',
    noPermissionsWithoutEdit:
      'Nie masz uprawnienia do edycji ról, więc nowa rola powstanie bez uprawnień.',
    readOnly: 'Podgląd — nie masz uprawnień do zmiany tej roli.',
    save: 'Zapisz zmiany',
    systemRole: 'Rola systemowa',
    systemRoleHint: 'Rola wbudowana: nie można jej usunąć ani zmienić jej nazwy.',
    systemRoleNameHelper: 'Nazwy roli systemowej nie można zmienić.',
    unsavedChanges: 'Masz niezapisane zmiany',
  },
  history: {
    author: 'Kto',
    createdAt: 'Kiedy',
    description: 'Opis',
    empty: 'Brak zarejestrowanych zmian.',
    heading: 'Historia zmian',
    loadError: 'Nie udało się wczytać historii zmian. Spróbuj ponownie.',
    loading: 'Wczytywanie historii zmian',
    rowsPerPage: 'Wierszy na stronie',
    systemAuthor: 'System',
    type: 'Typ',
    types: {
      RECURRING_RESERVATION_CHANGE: 'Zmiana rezerwacji stałej',
      ROLE_CHANGE: 'Zmiana uprawnień',
    },
  },
  list: {
    ariaLabel: 'Lista ról',
    empty: 'Brak ról.',
    heading: 'Role',
    hierarchyLevel: 'Poziom {{level}}',
    newRole: 'Nowa rola',
    system: 'Systemowa',
  },
  matrix: {
    ariaLabel: 'Macierz uprawnień roli',
    heading: 'Uprawnienia',
    lockedPermissions:
      'Rola Administrator zawsze zachowuje odczyt i edycję ról, aby nikt nie utracił dostępu do zarządzania rolami.',
  },
  tabs: {
    ariaLabel: 'Widok strony ról',
    history: 'Historia zmian',
    roles: 'Role',
  },
};
